import React, { useState } from 'react';
import MessageContext from './MessageContext';

const defaultMessageContext = {
  text: '',
  refresh: false,
  severity: 'info',
  data: {}
};
const MessageContextProvider = (props) => {
  const [messageContext, setMessageContext] = useState(defaultMessageContext);
  const value = { messageContext, setMessageContext };
  return <MessageContext.Provider value={value} {...props} />;
};

export default MessageContextProvider;
